<template>
  <div class="lock-sim-card">
    <SimonModal
      :is-visible="openModal"
      :custom-modal-class="modalClass"
      id="sim-lock-modal"
      @hide="closeModal"
      @btnLeft="closeModal"
      @btnRight="lockSimCard"
      :show-footer-buttons="showNextButton"
      :btn-left-title="cancelTitle"
      :btn-right-title="okTitle">
      <template v-slot:modalTitle>
        <slot name="headerModal"></slot>
      </template>
      <slot name="infoModal"></slot>
    </SimonModal>

    <slot :name="'headImg' + postSlotName"></slot>
    <slot :name="'header' + postSlotName"></slot>
    <slot :name="'info' + postSlotName"></slot>

    <div class="action-area" v-if="!isLocked">
      <button class="text" @click="clickMore()"><slot name="txtMore">mehr erfahren</slot></button>
      <button class="filled yellow" @click="clickLock()" :disabled="buttonDisabled"><slot name="txtLock">SIM-Karte sperren</slot></button>
    </div>
  </div>
</template>

<script>
import transaction from '@/mixins/transaction'
import { mapActions, mapGetters } from 'vuex'
import beErrors from '@/mixins/beErrors'
import customerContractState from '@/mixins/customerContractState'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'LockSimCardWrapper',
  data () {
    return {
      openModal: false,
      mode: null
    }
  },
  components: {
    SimonModal
  },
  mixins: [
    transaction('lockSimCard'),
    beErrors,
    customerContractState()
  ],
  watch: {
    isLocked: {
      immediate: true,
      handler: function (value) {
        this.$emit('update:lock-status', value)
      }
    }
  },
  methods: {
    ...mapActions('lockSimCard', [
      'requestLockSimCard'
    ]),
    clickMore: function () {
      this.mode = 'info'
      this.openModal = true
    },
    clickLock: function () {
      this.mode = 'lock'
      this.openModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'suspend simcard',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    lockSimCard () {
      const comp = this
      this.$emit('error-clear')
      const data = {
        information_action: 'submit',
        information_name: 'suspend simcard',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
      this.requestLockSimCard().catch(_ => {
        const message = comp.beErrorGetLastMessage()
        this.errorToast(message)
      }).finally(() => {
        this.openModal = false
      })
    },
    closeModal: function () {
      this.openModal = false
    }
  },
  computed: {
    ...mapGetters('lockSimCard', {
      sessionStatus: 'currentStatus'
    }),
    buttonDisabled: function () {
      return (!this.loadedContractState || this.contractTerminated)
    },
    isLocked: function () {
      return this.isSimCardLocked || this.sessionStatus === 'running'
    },
    // in b-modal, we cannot fully remove the ok button without replacing the whole footer
    // use a css class on footer to hide ok button when in "info-mode">
    showNextButton: function () {
      return this.mode === 'lock'
    },
    modalClass: function () {
      return this.mode === 'lock' ? 'danger-modal' : 'info-modal'
    },
    cancelTitle: function () {
      if (this.mode === 'lock') {
        return this.cancelTitleLock
      }
      return this.cancelTitleInfo
    },
    cancelTitleLock: function () {
      return this.$slots.btnCancelLock?.[0]?.text || 'Abbrechen'
    },
    cancelTitleInfo: function () {
      return this.$slots.btnCancelInfo?.[0]?.text || 'Schließen'
    },
    okTitle: function () {
      return this.$slots.btnLock?.[0]?.text || 'SIM-Karte sperren'
    },
    postSlotName: function () {
      return this.isLocked ? 'Locked' : ''
    }
  }
}
</script>
